import { DAYS_OF_WEEK } from '../constants/date'

export default ({ dayOfWeek, day, month }) =>
  `${DAYS_OF_WEEK[dayOfWeek]} ${day}/${month}`
